import { render } from "./InputCheckbox.vue?vue&type=template&id=74f98cd6"
import script from "./InputCheckbox.vue?vue&type=script&lang=js"
export * from "./InputCheckbox.vue?vue&type=script&lang=js"
script.render = render

export default script